<template>
    <div class="activity_page">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class="index_bg">
                <img src="./img/index_bg.png"
                     class="index_bg" />
                <div class="back">
                    <img src="./img/img_icon_01.png"
                         @click="goback"
                         class="back" />
                </div>
                <div class="left_menu">
                    <img src="./img/icon_invate.png"
                         @click="handleJump('/activity/2023shujia/timing')"
                         class="item"
                         alt=" " />
                    <img src="./img/icon_rule.png"
                         @click="show_rule"
                         class="item"
                         alt=" " />
                </div>
            </div>
            <div class="desc">
                <p class="title">系统根据测评结果</p>
                <p>为每位学生自动生成专属个性化暑假作业</p>
                <p>可复习本学期未掌握知识、预习下学期课程</p>
            </div>
            <div class="unit_list"
                 v-if="class_list.length">
                <div class="item"
                     v-for="(item, index) in class_list"
                     :key="index">
                    <i class="icon"
                       :class="item.sid == 51 ? 'sid51' : 'sid21'"></i>
                    <p class="unit_name">{{ item.unit_name }}</p>
                    <span class="btn"
                          @click="share(item)">发布作业</span>
                    <span class="btn"
                          @click="view(item)">查看完成情况</span>
                </div>
            </div>
            <div class="lottery">
                <div class="title">赢取好礼</div>
                <div class="user-info">
                    <div class="my-integral">
                        <span class="avatar">
                            <img src="https://cdn.m.tbkt.cn/tea_default.png">
                        </span>
                        <div class="text">
                            <strong>我的积分 <span>{{ power }}</span></strong>
                            <p>学生做作业，老师得积分</p>
                        </div>
                    </div>
                    <span class="detail-integral"
                          @click="handleJump('/activity/2023shujia/pointsdetail')">积分明细></span>
                </div>
                <div class="award-list">
                    <div class="award-item"
                         v-for="(item, index) in level_info"
                         :key="index">
                        <div class="gold">
                            <img :src="item.price == 20 ? require('./img/gold20.png') : item.price == 30 ? require('./img/gold30.png') : item.price == 50 ? require('./img/gold50.png') : ''"
                                 class="gold-img">
                            <img :src="item.is_win == 1 ? require('./img/winner.png') : require('./img/no-winner.png')"
                                 v-if="item.status == 1"
                                 class="winner-img">
                        </div>
                        <!--status: 0, //未抽奖   1已抽奖-->
                        <!--click_status: 0,//不可抽奖   1可以抽奖-->
                        <!--is_win:0  //未中奖   1已中奖 -->
                        <div class="text">
                            <strong>获得{{ item.level * 100 }}积分</strong>
                            <p>即可立即抽奖</p>
                            <p>当前{{ item.num }}人已抽奖</p>
                            <span class="btn "
                                  :class="item.click_status == 1 && item.status == 0 ? 'hav-lucky' : ''"
                                  @click="handleAward(item)">
                                {{ item.status == 1 ? '已抽奖' : item.click_status == 1 ? "立即抽奖" : "未达标准" }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 活动规则弹窗 -->
            <div class="active-rule-bg"
                 v-if="showRule">
                <div class="rule-content">
                    <img src="./img/icon_close.png"
                         class="close-btn"
                         @click="closeRule"
                         alt="">
                    <h3 class="title">活动规则</h3>
                    <p><strong>1</strong>活动时间：<span>2025年7月1日00:00:00至2025年8月15日12:00:00</span></p>
                    <p><strong>2</strong>本活动短信邀请次数计入当月发作业次数。</p>
                    <p><strong>3</strong>学生每完成一次作业，老师即可获得1积分。</p>
                    <p><strong>4</strong>达到积分要求即可参与抽奖。</p>
                    <p><strong>5</strong>活动奖励会在活动结束后进行发放。</p>
                    <p><strong>6</strong>活动数据更新可能会有延迟。</p>
                    <p><strong>7</strong>在参与活动过程中，如用户出现违规行为，同步 课堂有权取消其获奖资格。</p>
                </div>
            </div>
            <!-- 抽奖结果页 -->
            <div class="award-result-bg"
                 v-if="awardResult">
                <div class="award-result">
                    <template v-if="awardResult == 1">
                        <img src="./img/award-bg2.png"
                             class="result-pic"
                             alt="">
                        <p class="result-txt">金币与您擦肩而过</p>

                    </template>
                    <template v-if="awardResult == 2">
                        <img src="./img/award-bg1.png"
                             class="result-pic"
                             alt="">
                        <p class="result-txt">抽中{{ goldNum }}金币</p>
                        <img :src="goldImg"
                             class="gold-num"
                             alt="">
                    </template>
                    <span class="btn"
                          @click="closeAward">确定</span>
                </div>
            </div>
            <!-- H5分享页 -->
            <div class="active-rule-bg"
                 v-if="showShare">
                <div class="rule-content share-box">
                    <div class="share_content">
                        <img src="./img/icon_link.png"
                             alt=" " />
                        <strong>链接已复制</strong>
                        <p><span>{{ unit_name }}</span>暑假作业链接已复制，在班级群的输入框进行粘贴，然后点击发送即可</p>
                        <span class="btn"
                              @click="shareClose">确定</span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
export default {
    components: {
        loadings
    },
    data () {
        return {
            loading: false,
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            summer_year: 1,
            level_info: [],
            class_list: [],
            power: 0,
            showRule: false,
            //抽奖结果页 0:关闭结果页  1：未中奖   2：中奖
            awardResult: 0,
            goldNum: 0,
            goldImg: '',
            showShare: false,
            unit_name: '',//仅用于分享弹窗
            copyValue: '',//分享链接
        }
    },
    created () {
        this.activityIndexData()
    },
    mounted () {
        //加个滚动代替触摸，防止返回后白页面
        setTimeout(() => {
            window.scrollTo(0, 1);
        }, 100);
    },
    methods: {
        activityIndexData () {
            let url = API_URL_HD_API + '/summer/tea/index/'
            let params = {
                summer_year: this.summer_year
            }
            this.loading = true
            this.$http.post(url, params).then(res => {
                this.loading = false
                if (res.data.response === 'ok') {
                    this.power = res.data.data.power
                    this.level_info = res.data.data.level_info
                    this.class_list = res.data.data.class_list
                }
            })
        },
        goback () {
            this.appFunction("ys_finish", "", 1);
        },
        //跳转
        handleJump (str) {
            this.$router.push(str)
        },
        //打开活动规则
        show_rule () {
            this.showRule = true
        },
        closeRule () {
            this.showRule = false
        },
        //立即抽奖
        handleAward (e) {
            if (e.status != 0 || e.click_status != 1) {
                return
            }
            layer.open({ type: 2, shadeClose: false, });
            let url = API_URL_HD_API + '/summer/tea/tea_lottery/'
            let params = {
                summer_year: this.summer_year,
                level: e.level
            }
            this.$http.post(url, params).then(res => {
                layer.closeAll();
                if (res.data.response === 'ok') {
                    if (res.data.data.lottery_count) {
                        this.awardResult = 2;
                        this.goldNum = res.data.data.lottery_count;
                        this.goldImg = e.level == 1 ? require('./img/icon-gold20.png') : e.level == 2 ? require('./img/icon-gold30.png') : require('./img/icon-gold50.png')
                    } else {
                        this.awardResult = 1;
                    }
                }
            })
        },
        closeAward () {
            this.activityIndexData()
            this.awardResult = 0

        },
        share (unit) {
            layer.open({ type: 2, shadeClose: false, });
            this.$http.post(API_URL_HD_API + '/summer/tea/send_task/', {
                summer_year: this.summer_year,
                unit_class_id: unit.unit_class_id,
                sid: unit.sid
            }).then(res => {
                layer.closeAll();
                if (res.data.response === 'ok') {
                    let url = res.data.data;
                    if (this.inApp) {
                        let title = unit.unit_name + "暑假作业";
                        let content = "点击参加" + unit.unit_name + "暑假作业";
                        this.appFunction("ys_share", `${title},${content},${url},2,${unit.unit_class_id},0,5,暑假作业活动分享`);
                    } else {
                        this.unit_name = unit.unit_name
                        let coptText = `${unit.unit_name}暑假作业，链接：${url}`
                        this.copyValue = coptText
                        this.showShare = true
                    }
                }
            })

        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
        shareClose () {
            this.copyText(this.copyValue)
            this.showShare = false
        },
        view (item) {
            this.$router.push(`/activity/2023shujia/detail/${item.sid}/${item.unit_class_id}?summer_year=${this.summer_year}`)
        }
    }
}
</script>

<style lang="scss" scoped>
.activity_page {
    min-height: 100vh;
    background: #eff5ff;
}

.index_bg {
    position: relative;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        padding: 15px;
        width: 16px / $ppr;
        height: 31px / $ppr;
    }

    .left_menu {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        right: 24px / $ppr;
        top: 50%;
        transform: translateY(-23%);

        .item {
            margin: 20px / $ppr 0;
            width: 98px / $ppr;
        }
    }
}

.desc {
    margin: 0 0 15px / $ppr;
    text-align: center;
    color: #707c89;
    text-shadow: 0 0 black;
    p {
        padding: 7px / $ppr 0;
        font-size: 24px / $ppr;
    }

    .title {
        font-size: 28px / $ppr;
    }
}

.unit_list {
    padding: 40px / $ppr 30px / $ppr;

    .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #fff;
        background: -webkit-linear-gradient(to right, #fff 0%, #e9f5ff 100%);
        margin-bottom: 26px / $ppr;
        border: 2px / $ppr solid #fff;
        border-radius: 10px / $ppr;
        padding: 30px / $ppr;
        box-shadow: 0px 3px / $ppr 6px / $ppr rgba(0, 153, 255, 0.1);

        .icon {
            width: 36px / $ppr;
            height: 36px / $ppr;

            &.sid21 {
                background: url("./img/icon_sx.png");
                background-size: 36px / $ppr 36px / $ppr;
            }

            &.sid51 {
                background: url("./img/icon_yw.png");
                background-size: 36px / $ppr 36px / $ppr;
            }
        }

        .unit_name {
            font-size: 36px / $ppr;
            color: #223f68;
            font-weight: bold;
            padding-right: 40px / $ppr;
        }

        .btn {
            font-size: 26px / $ppr;
            color: #fff;
            line-height: 62px / $ppr;
            border-radius: 31px / $ppr;
            padding: 0 24px / $ppr;
            background-color: #4b85ff;
            background: -o-linear-gradient(to right, #4b85ff 0%, #71c3fd 100%);
            background: -ms-linear-gradient(to right, #4b85ff 0%, #71c3fd 100%);
            background: linear-gradient(to right, #4b85ff 0%, #71c3fd 100%);
            background: -moz-linear-gradient(to right, #4b85ff 0%, #71c3fd 100%);
            background: -webkit-linear-gradient(to right, #4b85ff 0%, #71c3fd 100%);
        }
    }
}

.lottery {
    margin: 40px / $ppr 30px / $ppr;
    border: 4px / $ppr solid #fff;
    border-radius: 10px / $ppr;
    background-color: #e8f4ff;
    background: -webkit-linear-gradient(to bottom, #e8f4ff 0%, #f6fbff 20%);
    .title {
        width: 335px / $ppr;
        height: 70px / $ppr;
        margin: 0 auto;
        font-size: 38px / $ppr;
        color: #fff;
        background: url("./img/bg_win_gift.png") no-repeat center;
        background-size: 335px / $ppr 70px / $ppr;
        text-align: center;
        font-weight: bold;
        line-height: 80px / $ppr;
        position: relative;
        top: -10px / $ppr;
    }

    .user-info {
        padding: 25px / $ppr;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .my-integral {
            display: flex;
            align-items: center;

            .avatar {
                display: block;
                width: 110px / $ppr;
                height: 110px / $ppr;
                border-radius: 100%;
                border: 5px / $ppr solid #dde6ed;
                margin-right: 40px / $ppr;

                img {
                    display: block;
                    width: 110px / $ppr;
                    height: 110px / $ppr;
                    border-radius: 100%;
                }
            }

            .text {
                strong {
                    color: #223f68;
                    font-size: 34px / $ppr;
                    font-weight: bold;

                    span {
                        font-size: 44px / $ppr;
                        color: #fd302d;
                    }
                }

                p {
                    font-size: 24px / $ppr;
                    color: #959ca4;
                }
            }
        }

        .detail-integral {
            font-size: 26px / $ppr;
            color: #4a83ff;
        }
    }

    .award-list {
        padding: 48px / $ppr 57px / $ppr 0;
        background: #fff;

        .award-item {
            padding: 40px / $ppr 20px / $ppr 32px / $ppr 30px / $ppr;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px / $ppr solid #eaeaea;
            &:last-child {
                border-bottom: 0;
            }
            .gold {
                position: relative;

                .gold-img {
                    width: 189px / $ppr;
                    height: 214px / $ppr;
                }

                .winner-img {
                    position: absolute;
                    right: -30px / $ppr;
                    top: -30px / $ppr;
                    width: 106px / $ppr;
                    height: 106px / $ppr;
                }
            }

            .text {
                padding-top: 8px / $ppr;
                padding-right: 20px / $ppr;
                strong {
                    display: block;
                    color: #223f68;
                    font-weight: bold;
                    font-size: 32px / $ppr;
                    margin-bottom: 20px / $ppr;
                    line-height: 1;
                    position: relative;
                    top: 2px / $ppr;
                }

                p {
                    color: #999999;
                    font-size: 24px / $ppr;
                    margin-top: 16px / $ppr;
                    line-height: 1;
                }

                .btn {
                    display: block;
                    width: 200px / $ppr;
                    line-height: 62px / $ppr;
                    font-size: 30px / $ppr;
                    background: #bbbbbb;
                    color: #fff;
                    text-align: center;
                    border-radius: 62px / $ppr;
                    margin-top: 20px / $ppr;
                }

                .hav-lucky {
                    background-color: #fd302d;
                    background: -o-linear-gradient(
                        to right,
                        #fd302d 0%,
                        #fe965e 100%
                    );
                    background: -ms-linear-gradient(
                        to right,
                        #fd302d 0%,
                        #fe965e 100%
                    );
                    background: linear-gradient(to right, #fd302d 0%, #fe965e 100%);
                    background: -moz-linear-gradient(
                        to right,
                        #fd302d 0%,
                        #fe965e 100%
                    );
                    background: -webkit-linear-gradient(
                        to right,
                        #fd302d 0%,
                        #fe965e 100%
                    );
                }
            }
        }
    }
}

//活动规则弹窗
.active-rule-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);

    .rule-content {
        box-sizing: border-box;
        width: 672px / $ppr;
        padding: 0 35px / $ppr 30px / $ppr 45px / $ppr;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        position: relative;
        border-radius: 20px / $ppr;

        .title {
            width: 327px / $ppr;
            height: 63px / $ppr;
            line-height: 63px / $ppr;
            font-size: 36px / $ppr;
            text-align: center;
            margin: 0 auto 35px / $ppr;
            color: #fff;
            background: url("./img/rule_bg.png") no-repeat center;
            background-size: 327px / $ppr 63px / $ppr;
        }

        .close-btn {
            width: 29px / $ppr;
            height: 29px / $ppr;
            position: absolute;
            top: -50px / $ppr;
            right: 0;
        }

        p {
            font-size: 24px / $ppr;
            color: #333;
            line-height: 1.7;
            padding-left: 60px / $ppr;
            position: relative;
            margin-bottom: 35px / $ppr;

            strong {
                position: absolute;
                left: 0;
                top: 0;
                display: inline-block;
                width: 36px / $ppr;
                height: 36px / $ppr;
                line-height: 37px / $ppr;
                font-size: 28px / $ppr;
                color: #fff;
                text-align: center;
                border-radius: 40px / $ppr;
                background: #4a83ff;
            }

            span {
                color: #4a83ff;
                font-weight: bold;
            }
        }
    }
}

//抽奖结果页
.award-result-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);

    .award-result {
        width: 552px / $ppr;
        height: 826px / $ppr;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .result-txt {
            width: 100%;
            text-align: center;
            font-size: 32px / $ppr;
            color: #223f68;
            position: absolute;
            top: 31%;
            font-weight: bold;
        }

        .gold-num {
            width: 153px / $ppr;
            height: 121px / $ppr;
            position: absolute;
            left: 50%;
            top: 48%;
            transform: translate(-50%, -50%);
        }

        .btn {
            display: block;
            margin: 0 auto;
            font-size: 34px / $ppr;
            width: 420px / $ppr;
            height: 80px / $ppr;
            border-radius: 80px / $ppr;
            line-height: 80px / $ppr;
            color: #fff;
            text-align: center;
            position: relative;
            bottom: 120px / $ppr;
            background-color: #4c86ff;
            background: -o-linear-gradient(to right, #4c86ff 0%, #70c2fd 100%);
            background: -ms-linear-gradient(to right, #4c86ff 0%, #70c2fd 100%);
            background: linear-gradient(to right, #4c86ff 0%, #70c2fd 100%);
            background: -moz-linear-gradient(to right, #4c86ff 0%, #70c2fd 100%);
            background: -webkit-linear-gradient(to right, #4c86ff 0%, #70c2fd 100%);
        }
    }
}

.share_content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 65px / $ppr 0 27px / $ppr;
    img {
        display: block;
        margin: 0 auto 5px / $ppr;
        width: 331px / $ppr;
        height: 250px / $ppr;
    }

    strong {
        font-size: 34px / $ppr;
        color: #223f68;
        font-weight: bold;
        margin-bottom: 13px / $ppr;
    }

    p {
        font-size: 26px / $ppr;
        color: #959ca4 !important;
        margin-bottom: 90px / $ppr !important;
        padding: 0 35px / $ppr !important;
        span {
            font-size: 32px / $ppr;
            color: #4d8cff;
            font-weight: bold;
        }
    }

    .btn {
        display: block;
        font-size: 30px / $ppr;
        color: #fff;
        line-height: 80px / $ppr;
        border-radius: 40px / $ppr;
        padding: 0 140px / $ppr;
        background-color: #5dcffc;
        background: -o-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: -ms-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: -moz-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
        background: -webkit-linear-gradient(to right, #5dcffc 0%, #4a82ff 100%);
    }
}
.share-box {
    width: 600px / $ppr !important;
}
</style>
